export default __webpack_public_path__ + "static/media/phone.dcb7988c.png";